import Inro from "./Componets/Intro/Intro";
import About from "./Componets/About/About";
import ProductList from "./Componets/Productlist/Productlist";

import Contect from "./Componets/Contect/Contect";
const App=()=> {
  
  return (
 
  <div >

  
    <Inro/>
 <About/>

 <ProductList/>

 
 <Contect/>
  </div>
  );
}

export default App;
